import { render, staticRenderFns } from "./view_kimi.vue?vue&type=template&id=55ccc232&scoped=true"
import script from "./view_kimi.vue?vue&type=script&lang=js"
export * from "./view_kimi.vue?vue&type=script&lang=js"
import style0 from "./view_kimi.vue?vue&type=style&index=0&id=55ccc232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccc232",
  null
  
)

export default component.exports